import { Controller } from 'stimulus'

export default class extends Controller {

  static targets = [ 'parent', 'frame' ]

  refresh = () => {
    this.frameTarget.src = this.frameTarget.dataset.src + '&' + this.parentTarget.name + '=' + this.parentTarget.value
  }
}

